import { render, staticRenderFns } from "./MedicalRecordShared.vue?vue&type=template&id=565e3f7c&scoped=true"
import script from "./MedicalRecordShared.vue?vue&type=script&lang=js"
export * from "./MedicalRecordShared.vue?vue&type=script&lang=js"
import style0 from "./MedicalRecordShared.vue?vue&type=style&index=0&id=565e3f7c&prod&lang=scss&scoped=true"
import style1 from "./MedicalRecordShared.vue?vue&type=style&index=1&id=565e3f7c&prod&lang=scss&scoped=true"
import style2 from "./MedicalRecordShared.vue?vue&type=style&index=2&id=565e3f7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565e3f7c",
  null
  
)

export default component.exports